import React from 'react'

function Blogview() {
  return (
    <div>Blogview</div>
  )
}

export default Blogview